import { Link } from 'react-router-dom';
import { quickEntries } from '@/mocks/site';

export default function QuickEntries() {
  return (
    <section className="mx-auto w-full px-4 md:px-8 py-10 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-600">按类型快速进入，找到你想看的影视内容</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
        {quickEntries.map((entry) => (
          <Link
            key={entry.key}
            to={`/category?type=${encodeURIComponent(entry.key)}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:p-5"
          >
            <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${entry.accent} text-background-50 md:h-14 md:w-14`}>
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-base font-semibold text-foreground-950">{entry.label}</span>
              <span className="mt-0.5 block truncate text-xs text-foreground-500">{entry.desc}</span>
            </span>
            <i className="ri-arrow-right-line ml-auto hidden text-foreground-300 transition-colors group-hover:text-accent-500 md:block"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}